import styled from 'styled-components/macro'

export const ToggleWrapper = styled.button<{ width?: string }>`
  display: flex;
  align-items: center;
  width: ${({ width }) => width ?? '100%'};
  padding: 4px;
  background: ${({ theme }) => theme.buttonSecondary};
  border-radius: 8px;
  border: ${({ theme }) => '1px solid ' + theme.borderTertiary};
  cursor: pointer;
  gap: 2px;
  outline: none;
`

export const ToggleElement = styled.span<{ isActive?: boolean; fontSize?: string }>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 12px;
  border-radius: 6px;
  justify-content: center;
  height: 100%;
  background: ${({ theme, isActive }) => (isActive ? theme.buttonPrimary : 'none')};
  color: ${({ theme, isActive }) => (isActive ? theme.textPrimary : theme.textSecondary)};
  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.borderAccent : 'transparent')};
  font-size: ${({ fontSize }) => fontSize ?? '14px'};
  font-weight: 500;
  white-space: nowrap;

  :hover {
    user-select: initial;
    color: ${({ theme }) => theme.buttonPrimaryText};
  }
`
